// extracted by mini-css-extract-plugin
export var playButton = "playButton-module--playButton--Uw8X7";
export var sbShowMain = "playButton-module--sb-show-main--VUWXF";